import React, {
  useEffect, useContext, useCallback,
} from 'react';
import { useTranslation } from 'react-i18next';
import useRouter from 'common/hooks/use-router';
import AlertsContext from 'common/contexts/alerts';
import usePriceArea from 'priceAreas/contexts/priceAreas';

import PageHeader from 'common/components/PageHeader/PageHeader';
import PageLoader from 'common/components/PageLoader/PageLoader';
import PriceAreaForm from './PriceAreaForm';

const PriceAreaFormPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);
  const {
    save, update, fetchItem, item: priceArea, isFetching,
  } = usePriceArea();

  const { id: priceAreaId } = router.match.params;

  useEffect(() => { fetchItem(priceAreaId); }, [fetchItem, priceAreaId]);

  const onSubmit = useCallback(async (priceArea) => {
    const payload = { ...priceArea };

    if (priceArea.id) {
      const res = await update(payload.id, payload);

      if (!res.error) {
        setAlert(t('priceAreas.successEdit'), 'success');
        router.push('/price-areas');
      } else {
        setAlert(res.message, 'danger');
      }
    } else {
      const res = await save(payload);

      if (!res.error) {
        setAlert(t('priceAreas.successAdd'), 'success');
        router.push('/price-areas');
      } else {
        setAlert(res.message, 'danger');
      }
    }
  }, [update, setAlert, t, router, save]);

  return (
    <>
      <PageLoader processing={isFetching} />
      <PageHeader
        title={t(`priceAreas.${priceArea && priceArea.id ? 'edit' : 'add'}PriceArea`)}
        subLink={{ url: '/price-areas', icon: 'arrow-left', label: t('common.back') }}
      />
      <section className="section form-page">
        <PriceAreaForm
          onSubmit={onSubmit}
          priceArea={priceArea}
        />
      </section>
    </>
  );
};

export default PriceAreaFormPage;
